module.exports = __webpack_public_path__ + "./fonts/icomoon.e583ccbcb8f007e63efd451b167704a8.svg";